import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"

const StyledDiv = styled.div`
  width: 600px;
  margin: 0 auto;
  padding-bottom: ${padding.small};
`

export default StyledDiv

export const LoadingWrapper = styled.div`
  padding: ${padding.tiny} ${padding.tiny};
`
